import type {Schemas} from 'domainTypes/dto';
import {ebsApi} from 'store/ebsApi';
import type {Media, MediasForEan} from './types';
import {mapMediasForEans} from './mappers';

const mediaApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getMediaByEans: build.query<
      MediasForEan[],
      {workId: string; eans: string[]},
      Schemas.MediaForEansDto
    >({
      keepUnusedDataFor: 120,
      query: ({eans}) => ({
        url: `media/ean`,
        body: eans,
        method: 'POST',
      }),
      transformResponse: mapMediasForEans,
      providesTags: (result = []) =>
        result.map(medias => ({type: 'Media' as const, id: medias.ean})),
      serializeQueryArgs: ({queryArgs}) => {
        const {workId} = queryArgs;
        // Omits eans from cache key, only cache by workId.
        return {workId};
      },
    }),
    getMediaUrl: build.query<
      string | undefined,
      Pick<Media, 'id'>,
      Schemas.DownloadInfoDto
    >({
      keepUnusedDataFor: 120,
      query: ({id}) => `media/${id}`,
      transformResponse: response => response.uri,
    }),

    deleteMedia: build.mutation<
      void,
      {ean: string; media: Pick<Media, 'subType' | 'fileNr'>}
    >({
      query: ({ean, media}) => ({
        url: `media/soft-delete/${ean}`,
        method: 'POST',
        params: {
          fileType: media.subType,
          fileNumber: media.fileNr,
        },
      }),
      invalidatesTags: (_, __, {ean}) => [{type: 'Media', id: ean}],
    }),
  }),
});

export const {
  useGetMediaByEansQuery,
  useDeleteMediaMutation,
  useGetMediaUrlQuery,
  useLazyGetMediaUrlQuery,
} = mediaApi;
